import API_BASE, { protectedApiFetch } from "../api";

const ANALYTICS_SESSION_ID_KEY = "reelitproAnalyticsSessionId";

function createSessionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `session-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 12)}`;
}

export function getAnalyticsSessionId() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return "";
  }

  try {
    const existing = window.sessionStorage.getItem(ANALYTICS_SESSION_ID_KEY);
    if (existing) {
      return existing;
    }

    const nextSessionId = createSessionId();
    window.sessionStorage.setItem(ANALYTICS_SESSION_ID_KEY, nextSessionId);
    return nextSessionId;
  } catch {
    return "";
  }
}

export function peekAnalyticsSessionId() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return "";
  }

  try {
    return window.sessionStorage.getItem(ANALYTICS_SESSION_ID_KEY) || "";
  } catch {
    return "";
  }
}

export function clearAnalyticsSessionId() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }

  try {
    window.sessionStorage.removeItem(ANALYTICS_SESSION_ID_KEY);
  } catch {
    // no-op
  }
}

function normalizePagePath(pagePath) {
  if (typeof pagePath === "string" && pagePath.trim()) {
    return pagePath.trim();
  }

  if (typeof window === "undefined") {
    return "";
  }

  return `${window.location.pathname}${window.location.search}`;
}

export async function trackProductEvent(
  eventName,
  { featureArea = "", pagePath = "", metadata = {} } = {}
) {
  const normalizedEventName = String(eventName || "").trim();
  if (!normalizedEventName) {
    return false;
  }

  try {
    const response = await protectedApiFetch(
      `${API_BASE}/analytics/events`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_name: normalizedEventName,
          feature_area: featureArea || undefined,
          page_path: normalizePagePath(pagePath) || undefined,
          session_id: getAnalyticsSessionId() || undefined,
          metadata:
            metadata && typeof metadata === "object" && !Array.isArray(metadata)
              ? metadata
              : {},
        }),
        keepalive: true,
      }
    );
    return response.ok;
  } catch {
    return false;
  }
}
